import { createSelector } from '@reduxjs/toolkit'
import { createSelectorCache, getOrBuildSelector } from '../../Sinks/Selector/SelectorCache.ts'
import type { FilteredBucketValues } from '../../Sinks/Selector/CubeFiltering.ts'
import { selectFilteredCube } from '../../Sinks/Selector/SelectFilteredCube.ts'
import { forwardCubeStatus, selectCubeContext } from '../../Sinks/Selector/CubeContext.ts'
import type { KronaFilterOpts, TransformResult } from '../Types.ts'
import type { State } from '../../../../../Flux/Slice/index.ts'
import type { SourceId } from '../../../../../Flux/Slice/Visualization/VisualizationSliceTypes.ts'

const selectorCache = createSelectorCache<TransformResult<FilteredBucketValues[]>>()

export function selectKronaFilteredBuckets(
  state: typeof State,
  sourceId: SourceId,
  _bucketKey: string | undefined,
  opts: KronaFilterOpts,
  optsKey: string
): TransformResult<FilteredBucketValues[]> {
  const cacheId = `${sourceId}|${optsKey}`

  return getOrBuildSelector(selectorCache, cacheId, () =>
    createSelector(
      [
        (s: typeof State) => selectCubeContext(s, sourceId),
        (s: typeof State) =>
          selectFilteredCube(s, sourceId, { selectedPath: opts.selectedPath, gradeThreshold: opts.gradeThreshold })
      ],
      (ctx, value): TransformResult<FilteredBucketValues[]> => {
        if (ctx.status !== 'ready') return forwardCubeStatus(ctx)
        return { status: 'ready', value }
      }
    )
  )(state)
}
